import { moneyHidden } from '@/utils/currencyFormatter';
export type TodayParts = { todayCoins: number; todayVouchers: number; todayOnline?: number };
export type RevenueParts = { totalCoins: number; gcashRevenue?: number; voucherRevenue?: number };

/**
 * A device row's money today: coins + printed vouchers + online sales (net,
 * what the operator receives), for the main vendo and its sub-vendos. Online
 * was missing until 2026-09-29, when two ₱82.10 Maya sales sat in Transaction
 * History and on no card or row (Ray).
 */
export function todayTotal(d: TodayParts, subs: TodayParts[] = []): number {
   const one = (p: TodayParts) => p.todayCoins + p.todayVouchers + (p.todayOnline ?? 0);
   return one(d) + subs.reduce((sum, s) => sum + one(s), 0);
}

/**
 * ONE vendo's money, all time: coins + online sales (net) + printed vouchers
 * redeemed. Each card and row shows its OWN figure — a main card no longer
 * adds its sub-vendos, a sub-vendo row no longer shows coins only. JuanFi's
 * hEX (2026-10-28): every QR Ph sale sat on the VLAN sub-vendo, whose row
 * read ₱0 while the main card read ₱677.05 and the operator asked why the
 * main "recorded" his VLAN's sales.
 */
export function ownRevenue(p: RevenueParts): number {
   return p.totalCoins + (p.gcashRevenue ?? 0) + (p.voucherRevenue ?? 0);
}

/**
 * Pesos for a card or row: centavos to two places, whole pesos bare. A raw
 * float sum reached a device card as ₱246.29999999999998 (Ray, 2026-09-29).
 */
export function money(n: number): string {
   // Helping an account with money amounts hidden: the server sent 0 — show
   // the mask, never a number (callers put the ₱ in front).
   if (moneyHidden()) return '••••';
   const whole = Math.abs(Math.round(n * 100) % 100) === 0;
   return n.toLocaleString('en-PH', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: 2,
   });
}
